import { documentTypeToPatchCategory } from "./documentPatchCategory";

/** CustomPdfUploader の documents.${document_type} を API 送信用ペイロードに変換 */
export async function encodeSectionDocumentPayloads(
  rawDocs: Record<string, File[] | undefined> | undefined,
): Promise<{ category: string; files: unknown[] }[]> {
  const documentPayloads: { category: string; files: unknown[] }[] = [];
  if (!rawDocs || typeof rawDocs !== "object") return documentPayloads;

  for (const [documentType, fileList] of Object.entries(rawDocs)) {
    const files = Array.isArray(fileList)
      ? fileList.filter((x): x is File => x instanceof File)
      : [];
    if (files.length === 0) continue;
    const encoded: unknown[] = [];
    for (const file of files) {
      const item = await new Promise<any>((resolve) => {
        const reader = new FileReader();
        reader.onload = () =>
          resolve({
            data: String(reader.result || ""),
            originalFileName: file.name,
            mimeType: file.type || "application/pdf",
          });
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(file);
      });
      if (item) encoded.push(item);
    }
    if (!encoded.length) continue;
    documentPayloads.push({
      category: documentTypeToPatchCategory(documentType),
      files: encoded,
    });
  }
  return documentPayloads;
}
